import React, { useEffect, useRef, useState } from 'react';
import './ReviewItem.style.css';
import { Thumbnail } from 'components';

import Star from 'assets/icon/star_icon.png';
import moment from 'moment';
import { DownOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
const ReviewItem = ({
  reviewId,
  score,
  created_at,
  content,
  name,
  option,
  img,
  size = 100,
  maxHeight = 84,
  onReviewDetail = () => {},
}) => {
  const param = useParams();
  const [route] = param['*']?.split('/');
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(24);
  const [isMore, setIsMore] = useState(false);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  useEffect(() => {
    if (contentRef) {
      const height = contentRef.current.clientHeight;
      setContentHeight(height);
    }
  }, [contentRef, maxHeight]);

  /* ===== Render ===== */
  return (
    <div className="review_item_layout">
      {/* 마이 페이지 리뷰 화면 */}
      <div className="review_item">
        <ul className="review_info">
          <li>
            <img src={Star} alt="점수" />
            {parseFloat(score).toFixed(1) ?? 0.0}
          </li>
          <li>{name ? `${name[0]}**` : '비회원'}</li>

          <li>{moment(created_at).format(`YYYY.MM.DD`)}</li>
        </ul>
      </div>

      <div
        className="review_content"
        style={{
          maxHeight: isMore ? contentHeight : maxHeight,
        }}
      >
        <p ref={contentRef}>{content}</p>
      </div>
      {contentHeight > maxHeight && !isMore ? (
        <button onClick={() => setIsMore(!isMore)} className="moreButton">
          더보기 <DownOutlined />
        </button>
      ) : null}

      {/* {router === 'products' ? ( */}
      <div className="horizontal-scroll-container">
        {img && img.length
          ? img.map((_item, _index) =>
              _item.type === 'IMAGE' ? (
                <div>
                  <Thumbnail
                    key={`image-${_index}`}
                    size={size}
                    src={_item.file_url}
                    onClick={() =>
                      route === 'products' && onReviewDetail(reviewId)
                    }
                  />
                </div>
              ) : (
                <div>
                  <video
                    key={`video-${_index}`}
                    src={_item.file_url}
                    width={size}
                    height={size}
                    muted
                    {...(route !== 'products' && {
                      loop: true,
                      autoPlay: true,
                    })}
                    style={{
                      objectFit: 'cover',
                      cursor: 'pointer',
                    }}
                    onClick={() =>
                      route === 'products' && onReviewDetail(reviewId)
                    }
                  />
                </div>
              )
            )
          : null}
      </div>
    </div>
  );
};

export default ReviewItem;
